"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemanticColor = exports.NeutralColor = exports.SecondaryColor = exports.PrimaryColor = void 0;
var PrimaryColor;
(function (PrimaryColor) {
    PrimaryColor["PRIMARY_50"] = "#ECFDF6";
    PrimaryColor["PRIMARY_100"] = "#D1FAE8";
    PrimaryColor["PRIMARY_LV5"] = "#4DD7AF";
    PrimaryColor["PRIMARY_200"] = "#A8F2D6";
    PrimaryColor["PRIMARY_600"] = "#069584";
    PrimaryColor["PRIMARY_500"] = "#11B88E";
})(PrimaryColor || (exports.PrimaryColor = PrimaryColor = {}));
//Used alongside the primary to indicate to the user it’s the secondary focus.
var SecondaryColor;
(function (SecondaryColor) {
    SecondaryColor["SECONDARY_50"] = "#EFEFFE";
    SecondaryColor["SECONDARY_100"] = "#E1E2FE";
    SecondaryColor["SECONDARY_200"] = "#CACAFB";
    SecondaryColor["SECONDARY_300"] = "#ABA9F8";
    SecondaryColor["SECONDARY_400"] = "#9286F3";
    SecondaryColor["SECONDARY_500"] = "#826AEA";
    SecondaryColor["SECONDARY_600"] = "#744DDE";
    SecondaryColor["SECONDARY_LV1"] = "#ECFDF6";
    SecondaryColor["SECONDARY_LV10"] = "#382967";
    SecondaryColor["SECONDARY_LV11"] = "#291d49";
})(SecondaryColor || (exports.SecondaryColor = SecondaryColor = {}));
//Used to support primary and secondary colors in text colors, separators, etc.
var NeutralColor;
(function (NeutralColor) {
    NeutralColor["NEUTRAL_GREY_100"] = "#E7E7E7";
    NeutralColor["NEUTRAL_GREY_200"] = "#D1D1D1";
    NeutralColor["NEUTRAL_GREY_300"] = "#B0B0B0";
    NeutralColor["NEUTRAL_GREY_500"] = "#6D6D6D";
    NeutralColor["NEUTRAL_GREY_600"] = "#5D5D5D";
    NeutralColor["NEUTRAL_GREY_700"] = "#4F4F4F";
    NeutralColor["NEUTRAL_GREY_950"] = "#121212";
    NeutralColor["NEUTRAL_DARK"] = "#232323";
})(NeutralColor || (exports.NeutralColor = NeutralColor = {}));
var SemanticColor;
(function (SemanticColor) {
    SemanticColor["ERROR_100"] = "#F8C0C4";
    SemanticColor["ERROR_MEDIUM"] = "#E62E3A";
    SemanticColor["ERROR"] = "#E7424D";
    SemanticColor["ERROR_300"] = "#8A1C23";
    SemanticColor["WARNING_100"] = "#FFEFB3";
    SemanticColor["WARNING"] = "#F3D913";
    SemanticColor["WARNING_300"] = "#816600";
    SemanticColor["INFO_MEDIUM"] = "#1876FA";
    SemanticColor["SUCCESS_100"] = "#BEF3D9";
    SemanticColor["SUCCESS"] = "#34da87";
    SemanticColor["SUCCESS_300"] = "#146C40";
})(SemanticColor || (exports.SemanticColor = SemanticColor = {}));
